import { AlertTriangle, RotateCw } from "lucide-react";

// Estado de error reutilizable para listas/detalles: distinto de "vacío",
// siempre ofrece reintentar. Usar en vez de mostrar un "no hay resultados" falso.
export const ErrorState = ({ mensaje = "No se pudo cargar la información.", onRetry, testId = "error-state" }) => (
  <div data-testid={testId} className="flex flex-col items-center gap-3 py-16 text-center">
    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-500">
      <AlertTriangle size={22} />
    </span>
    <p className="max-w-sm text-sm text-red-600">{mensaje}</p>
    {onRetry && (
      <button
        data-testid={`${testId}-retry`}
        onClick={onRetry}
        className="inline-flex items-center gap-2 rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white px-4 py-2 text-sm font-medium text-[var(--tc-text-secondary)] transition-colors hover:bg-[var(--tc-surface)]"
      >
        <RotateCw size={14} /> Reintentar
      </button>
    )}
  </div>
);
